import ClubExam from '../../dto/club/ClubExam';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubExamRepository {

    static findByClubId(clubId, params = null) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams`, { params })
                .then(response => resolve(response.data.data.map(data => ClubExam.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getResultCountByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/result-count`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubExamId(clubExamId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/exams/${clubExamId}`)
                .then(response => resolve(ClubExam.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubExam) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/exams/${clubExam.id}`, clubExam.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(examId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/exams/${examId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(examId, archived) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/exams/${examId}/archived`, { archived: archived })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(clubId, clubExam) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/exams`, clubExam.serialize())
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
